const WELCOME_DOMAINS = ["@otta.com", "@wttj.co"];

export const isWelcomeEmail = (email: string): boolean => {
  return WELCOME_DOMAINS.some(domain => email.endsWith(domain));
};
